import { Box, Card, Grid, Typography } from '@mui/material';
import './portal-card-menu.scss';

interface PortalCardMenuProps {
  usersName?: string;
}

export const PortalCardMenu = ({ usersName }: PortalCardMenuProps) => {
  return (
    <>
      {/* ------------------------Home card----------------- */}
      <Grid
        size={{
          xs: 12,
          lg: 6,
        }}
      >
        <Card className="portal-card-menu home">
          <Grid container>
            <Grid size={12}>
              <Box className="land-text">
                <Typography className="land-header">
                  {usersName && `${usersName}'s Home`}
                </Typography>
                <Typography>
                  Once home model selection is finalized, a picture of it and
                  the home details will be shown here
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      {/* ------------------------Land card----------------- */}
      <Grid
        size={{
          xs: 12,
          lg: 6,
        }}
      >
        <Card className="portal-card-menu land">
          <Grid container>
            <Grid size={12}>
              <Box className="land-text">
                <Typography className="land-header">
                  {usersName && `${usersName}'s Land`}
                </Typography>
                <Typography>
                  Once lot selection is finalized, a picture of it and the lot
                  details will be displayed here
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Grid>{' '}
    </>
  );
};
